import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './SaveCancelButton.module.scss';

const makeChangeLabel = count => {
    const sOrNot = count === 1 ? '' : 's';
    return `${count} unsaved change${sOrNot}`;
};

export default class SaveCancelButton extends Component {
    static propTypes = {
        saveLabel: PropTypes.string,
        errorMessage: PropTypes.string,
        cancelLabel: PropTypes.string,
        changeLabel: PropTypes.string,
        changeCount: PropTypes.number,
        onSave: PropTypes.func,
        onCancel: PropTypes.func,
        wide: PropTypes.bool,
        saveDisabled: PropTypes.bool,
    };

    static defaultProps = {
        saveLabel: 'SAVE',
        cancelLabel: 'CANCEL',
        changeCount: 0,
        onSave: () => {},
        onCancel: () => {},
    };

    onClickSave = () => {
        const { onSave, saveDisabled } = this.props;
        if (!saveDisabled) {
            onSave();
        }
    };

    render() {
        const { saveLabel, cancelLabel, onCancel, changeCount, errorMessage, changeLabel, wide, saveDisabled } = this.props;
        const label = errorMessage || changeLabel || makeChangeLabel(changeCount);
        const showBanner = errorMessage || changeCount > 0;

        return (
            <div className={classNames(s.saveCancelButton, { [s.wide]: wide })}>
                {showBanner && (
                    <div className={classNames(s.changeBanner, { [s.errorBanner]: errorMessage })}>
                        <span className={classNames(errorMessage ? 'icon-warning' : 'icon-mapnote', s.icon)} />
                        <span>{label}</span>
                    </div>
                )}
                <div className={s.buttons}>
                    <div className={s.cancel} onClick={onCancel}>
                        {cancelLabel}
                    </div>
                    <button className={classNames(s.save, { [s.disabled]: saveDisabled })} onClick={this.onClickSave}>
                        {saveLabel}
                    </button>
                </div>
            </div>
        );
    }
}
